import { hapticImpact } from "@/lib/haptics";

export const SimpleButton = ({
  children,
  variant,
  className,
  disabled,
  onClick,
  loading,
}: {
  children: React.ReactNode;
  variant:
    | "blue"
    | "gray"
    | "purple"
    | "orange"
    | "green"
    | "beige"
    | "red"
    | "yellow"
    | "garnet"
    | "white"
    | "night";
  className?: string;
  disabled?: boolean | undefined;
  onClick?: () => void;
  loading?: boolean | undefined;
}) => {
  const variantClasses = {
    blue: {
      bg: "bg-pk-blue-3 hover:bg-pk-blue-4",
      text: "text-pk-gray-5",
    },
    gray: {
      bg: "bg-pk-gray-3 hover:bg-pk-gray-2",
      text: "text-pk-gray-5",
    },
    purple: {
      bg: "bg-pk-purple-3",
      text: "text-pk-gray-5",
    },
    orange: {
      bg: "bg-pk-orange-2 hover:bg-pk-orange-3",
      text: "text-pk-gray-5 group-hover:text-pk-orange-5",
    },
    green: {
      bg: "bg-pk-green-3 hover:bg-pk-green-4",
      text: "text-pk-gray-5",
    },
    beige: {
      bg: "bg-pk-beige-3 hover:bg-pk-beige-4",
      text: "text-pk-gray-5",
    },
    red: {
      bg: "bg-pk-red-3",
      text: "text-pk-gray-5",
    },
    yellow: {
      bg: "bg-pk-yellow-3",
      text: "text-pk-gray-5",
    },
    garnet: {
      bg: "bg-pk-garnet-3 hover:bg-pk-garnet-4",
      text: "text-pk-gray-5",
    },
    white: {
      bg: "bg-pk-gray-4",
      text: "text-pk-gray-2",
    },
    night: {
      bg: "bg-pk-night-1",
      text: "text-pk-gray-2",
    },
  } as const;

  const currentVariantClasses = variantClasses[variant];

  return (
    <button
      className={`rounded-sm  transition-all duration-200 shadow-cartoon-sm hover:shadow-cartoon active:scale-95 overflow-hidden relative px-2 py-0.5 group cursor-pointer ${currentVariantClasses.bg}  ${className}`}
      onClick={() => {
        if (!disabled && !loading) hapticImpact();
        onClick?.();
      }}
      disabled={disabled}
    >
      {loading && (
        <div className="absolute top-0 left-0 w-full h-full flex items-center justify-center bg-white/50 backdrop-blur">
          <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white"></div>
        </div>
      )}

      <span className={`transition  ${currentVariantClasses.text}`}>
        {children}
      </span>
    </button>
  );
};
